function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 8.4666665 8.4666669",
    height: 32,
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0.38572102)",
    id: "g943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect849",
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1.90985,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "M 0.13047683,0.60688537 H 8.3361898 V 1.6717998 H 0.13047683 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect869",
    style: {
      opacity: 1,
      fill: "#b0b0b0",
      fillOpacity: 1,
      strokeWidth: 1.80073,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "M 0.13047683,1.6717999 H 8.3361898 V 1.9515004 H 0.13047683 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect871",
    style: {
      opacity: 1,
      fill: "#616161",
      fillOpacity: 1,
      strokeWidth: 3.81586,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "M 0.13047583,0.36078662 H 8.3361908 V 0.6068854 H 0.13047583 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1.4345233,3.248192 h 5.59762 v 1.0649144 h -5.59762 z",
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1.5774,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    id: "rect849-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1.4345233,4.3131065 h 5.59762 V 4.592807 h -5.59762 z",
    style: {
      opacity: 1,
      fill: "#b0b0b0",
      fillOpacity: 1,
      strokeWidth: 1.48728,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    id: "rect869-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1.4345228,3.0020932 h 5.597621 V 3.248192 h -5.597621 z",
    style: {
      opacity: 1,
      fill: "#616161",
      fillOpacity: 1,
      strokeWidth: 3.15163,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    id: "rect871-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect849-3-5",
    style: {
      opacity: 1,
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.925712,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "m 2.9276098,6.1818063 h 2.611447 V 6.967955 h -2.611447 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect869-6-3",
    style: {
      opacity: 1,
      fill: "#b0b0b0",
      fillOpacity: 1,
      strokeWidth: 1.16281,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "m 2.9276098,6.967955 h 2.611447 v 0.366483 h -2.611447 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect871-7-5",
    style: {
      opacity: 1,
      fill: "#616161",
      fillOpacity: 1,
      strokeWidth: 2.41539,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.626993,
      paintOrder: "markers fill stroke",
      stopOpacity: 1
    },
    d: "m 2.9276098,5.8719714 h 2.611447 v 0.3098349 h -2.611447 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilter);
export default __webpack_public_path__ + "static/media/ico-filter.4160a592.svg";
export { ForwardRef as ReactComponent };